import { Box, Grid, Typography } from "@mui/material";
import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";

import "../../details/detailGrid/history/history.scss";
import { useResponsive } from "../../../../../hooks/useResponsive";
import { useCustomSearchParams } from "../../../../../hooks/useCustomSearchParams";
import AvatarSection from "./AvatarSection";
import HistoryDetails from "./HistoryDetails";

function FeedAssign({ history, showIcon = false, boardName }) {
  const navigate = useNavigate();
  const [data, updateSearchParams] = useCustomSearchParams("card_id");
  const isMobile = useResponsive("down", "md");

    // Memoize formatted date
    const formattedDate = useMemo(() => (
      moment.utc(history?.at_time)
        .local()
        .format(isMobile ? "MMM D, YYYY [at] h:mm A" : "MMMM D, YYYY [at] h:mm A")
    ), [history?.at_time, isMobile]);

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid
        container
        spacing={2}
        sx={{
          width: isMobile
            ? "calc(100% - 10px) !important"
            : "calc(100% + 16px) !important",
        }}
        className="worklog-item d-flex justify-content-space-between">
        <Grid
          item
          xs={isMobile ? 12 : 8}
          className="feed-assignee"
          sx={{ paddingLeft: isMobile && "8px !important" }}>
          <div className="d-flex w-100">
            <AvatarSection history={history} showIcon={showIcon} />
            <HistoryDetails
              history={history}
              boardName={boardName}
              updateSearchParams={updateSearchParams}
            />
          </div>
        </Grid>
        <Grid
          item
          xs={isMobile ? 12 : 4}
          sx={{ paddingTop: isMobile && "0px !important" }}>
          <div className={"d-flex align-items-center justify-content-end"}>
            <p className="worklog-date-time comment-date comment">
              Updated on{" "}
            </p>
            <Typography className="worklog-date-time comment-date">
              {formattedDate}
            </Typography>
          </div>
        </Grid>
      </Grid>
    </Box>
  );
}

export default React.memo(FeedAssign);
